import { RepositoryFactory } from "@/_repositories/repository-factory";
const CategoryRepository = RepositoryFactory.get("categories");
import authstore from '@/store/modules/auth';
import { clients } from '@/services/client.factory'

const categories = {
    namespaced: true,
    state: {
        item: null,
        items: [],
        error: null,
        errors: {},
    },
    getters: {
        item: (state) => state.item,
        items: (state) => state.items,
        error: (state) => state.error,
        errors: (state) => state.errors,
    },
    mutations: {
        CATEGORY_SET_ITEM(state, item) {
            Object.assign(state, { item })
        },
        CATEGORY_UPDATE_ITEM(state, item) {
            state.item = Object.assign({}, state.item, item)
        },
        CATEGORY_SET_ITEMS(state, items) {
            Object.assign(state, { items })
        },
        CATEGORY_SET_ERROR(state, error) {
            Object.assign(state, { error })
        },
        CATEGORY_SET_ERRORS(state, errors) {
            Object.assign(state, { errors })
        },
        CATEGORY_REMOVE_ITEM(state, item) {
            console.log("itemmmmm", item)
            const index = state.items.findIndex(i => i.id === item.id);
            console.log("indexxx",index)
            state.items.splice(index, 1);
        }
    },
    actions: {
        getItem(context, id) {
        },
        async getItems({ commit }, id) {
            await CategoryRepository.getCategories(id)
                .then((res) => res.list)
                .then((list) => {
                    commit('CATEGORY_SET_ITEMS', list)
                });
        },
        async addCategory(context,category) {
            console.log("create category")
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            return await clients.placeServiceClient.addCategory({cityCode:jwt.city_code, name:category.name, icon:category.icon, categoryGroupId:category.categoryGroupId, isVisible:category.isVisible})
        },
        async updateCategory(context,category) {
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            return await clients.placeServiceClient.updateCategory({cityCode:jwt.city_code, name:category.name, icon:category.icon, categoryId:category.categoryId, parentCategoryId:category.parentCategoryId, isVisible:category.isVisible})
        
        },
        async removeCategory({ commit }, category) {
            console.log("remove cetegoryyy", category.id)
            console.log("remove cetegoryyy", category)
            await clients.placeServiceClient.deleteCategory(category.id);
            commit('CATEGORY_REMOVE_ITEM', category);
        },
        async addExtraField(context,field) {
            console.log("addExtraField is called")
            let body = {
                categoryId:field.categoryId,
                fieldName:field.fieldName,
                fieldType:field.fieldType,
            }
            console.log("addExtraField body:", body);
            return await clients.placeServiceClient.addCategoryExtraField(body)
        },
        async getExtraFields({ commit }, id) {
            return await clients.placeServiceClient.getExtraFields(id);
        },

        async deleteExtraField(categoryId,extraFieldId){
            console.log("deleteExtraField is called with categoryId = " + categoryId + " extraFieldId = " + extraFieldId)
            return await clients.placeServiceClient.deleteCategoryExtraField(categoryId,extraFieldId);
        }
    }
}

export default categories;